module.exports = __webpack_public_path__ + "img/offer_banner_placeholder.542d429.png";